import { type QueryClient } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { REACT_QUERY_DEVTOOLS_ENABLED } from '../../config/config';

const QueryDevTools = (_: { client: QueryClient }) =>
    REACT_QUERY_DEVTOOLS_ENABLED === 'true' ? (
        <ReactQueryDevtools
            initialIsOpen={false}
            buttonPosition="bottom-left"
        />
    ) : null;

export default QueryDevTools;
